const baseTitle = {
  color: "primary.main",
  textAlign: "center",
  fontWeight: "500",
  p: "0 1rem",
};

export const styles = {
  clinicName: {
    ...baseTitle,
    fontSize: { xs: "1rem", sm: "1.4rem" },
  },
  clinicSubtitle: {
    ...baseTitle,
    fontSize: { xs: "0.8rem", sm: "1.2rem" },
  },
  timeSlotsContainer: {
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%",
  },
  timeSlotButton: (isSelected) => ({
    width: "100px",
    whiteSpace: "nowrap",
    fontWeight: isSelected ? "700" : "500",
    border: isSelected ? "2px solid" : "none",
    borderColor: isSelected ? "inherit" : "transparent",
  }),
  actionButtonsContainer: {
    display: "flex",
    justifyContent: { xs: "center", sm: "flex-end" },
    gap: "1rem",
    m: "0rem",
    p: "1rem",
  },
  dialog: {
    width: "100%",
    minWidth: "300px",
    maxWidth: "35rem",
    p: { xs: "0.5rem", sm: "1rem" },
  },
  dialogTitle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    p: 0,
    m: 0,
    gap: 1,
  },
  dialogContent: {
    alignItems: "center",
    width: "100%",
    px: 0,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
  timeIcon: {
    color: "primary.main",
    fontSize: { xs: "1rem", sm: "1.5rem" },
  },
  timeStack: {
    width: "100%",
    maxWidth: "12rem",
    justifyContent: "center",
    alignItems: "center",
  },
  timePeriodStack: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    pt: 1.5,
    pb: 1,
  },
};
